export interface MyonApiErrorResponse<T = null> {
	status: "error";
	message: string;
	timestamp: number;
	result: T;
}

export interface MyonApiSuccessResponse<T = any> {
	status: "success";
	timestamp: number;
	message: string|null;
	result: T;
}

export type MyonApiResponse<S = any, E = any> = MyonApiErrorResponse<E>|MyonApiSuccessResponse<S>;

export function isMyonApiSuccess<S = any, E = null>(response: MyonApiResponse<S, E>): response is MyonApiSuccessResponse<S> {
	return response.status === "success";
}

export function mustGetMyonApiResult<S = any>(response: MyonApiResponse<S>): S {
	if (!isMyonApiSuccess<S>(response)) {
		throw new Error("Invalid response");
	}
	return response.result;
}
